import { put, takeLatest } from "redux-saga/effects";
import { requestWorkstationBookingList,requestAddWorkstationBookingDetails} from "services/workstation";
import {
    fetchWorkstationBookingListRequest,
    fetchWorkstationBookingListSuccess,
    fetchWorkstationBookingListFailure,
    addWorkstationBookingRequest,
    addWorkstationBookingSuccess,
    addWorkstationBookingFailure,
  
} from "redux/reducers/workstation";

export function* watchWorkstation() {
  yield takeLatest(fetchWorkstationBookingListRequest, fetchWorkstationBookingList);
  yield takeLatest(addWorkstationBookingRequest, addWorkstationBooking);
}
function* fetchWorkstationBookingList({ payload }) {
  try {
    const response = yield requestWorkstationBookingList(payload);
    yield put(fetchWorkstationBookingListSuccess(response));
  } catch (error) {
    yield put(fetchWorkstationBookingListFailure("Failed to get list of workstation"));
  }
}

/**
 *
 * @param {WorkstationState} param0
 */
 function* addWorkstationBooking({ payload }) {
  try {
    const response = yield requestAddWorkstationBookingDetails(payload);
    yield put(addWorkstationBookingSuccess(response.data));
  } catch (error) {
    yield put(
        addWorkstationBookingFailure(
        "Failed to create add Workstation Booking"
      )
    );
  }
}

